import { useMemo } from "react"
import { useQuery } from "urql"

import { GetProductSourceChangeRecordsDocument } from "@/graphql/codegen/graphql"
import type { ProductSourceChangeRecord, ProductSourceChangeRecordsInput } from "@/graphql/codegen/graphql"

interface UseGetProductSourceChangeRecordsReturn {
  sourceChanges: ProductSourceChangeRecord[]
  pageCount: number
  isFetching: boolean
  error: Error | undefined
}

export const useGetProductSourceChangeRecords = (
  input: ProductSourceChangeRecordsInput
): UseGetProductSourceChangeRecordsReturn => {
  const [{ data, fetching, error }] = useQuery({
    query: GetProductSourceChangeRecordsDocument,
    variables: {
      input,
    },
  })

  const output = data?.productSourceChange.records

  const sourceChanges = useMemo<ProductSourceChangeRecord[]>(
    () =>
      output?.__typename === "ProductSourceChangeRecordsSuccess" ? (output.items as ProductSourceChangeRecord[]) : [],
    [output]
  )
  const total = output?.__typename === "ProductSourceChangeRecordsSuccess" ? output.pageInfo.total : 0

  return {
    sourceChanges,
    pageCount: input.limit ? Math.ceil(total / input.limit) : 1,
    isFetching: fetching,
    error: error,
  }
}
